/* ============
 * The initial state of the assessments module.
 * ============
 */
export default {
  assessments: [],
  assessment: {},
  totalCount: 0,
  assessmentLoading: false,
  assessmentSymptoms: []
};
